const localisation = {
    selector: {
        label: "Product",
        noOptionsLabel: "No Options",
        loadingLabel: "Loading...",
        placeholder: "Type to search",
    },
    partitionsByProductTable: {
        columns: {
            product: {
                headerName: "Product",
                description: "",
            },
            partitionName: {
                headerName: "Partition Name",
                description: "",
            },
            partitionReference: {
                headerName: "Partition Reference",
                description: "",
            },
            quantity: {
                headerName: "Quantity",
                description: "",
            },
        },
    },
    "unManagedProduct":"Product is NOT partition-managed"
};

export default localisation;
